import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import AppRoutes from './routes/AppRoutes.jsx'
import AppProviders from './shared/AppProviders.jsx'
import AppThemeProvider from './theme/AppThemeProvider.jsx'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <AppThemeProvider>
      <AppProviders>
        <AppRoutes />
      </AppProviders>
    </AppThemeProvider>
  </StrictMode>,
)
